import { QueryClient, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { ManualPaymentSlip, Pagination } from '@/types'

export type ListManualPaymentSlipsParams = {
  company_key: string
  due_month?: number
  due_year?: number
  page_size?: number
  paid?: boolean
}

export async function listManualPaymentSlips({
  company_key,
  ...params
}: ListManualPaymentSlipsParams) {
  const response = await httpClient('accounting-dealer').get<
    Pagination<ManualPaymentSlip>
  >(`/v3/company/${company_key}/manual-payment-slips`, {
    params,
  })

  return response.data
}

export const MANUAL_PAYMENT_SLIPS_QUERY_KEY = ['manual-payment-slips'] as const

export function invalidateManualPaymentSlipsQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: MANUAL_PAYMENT_SLIPS_QUERY_KEY })
}

export function useListManualPaymentSlips(
  params: ListManualPaymentSlipsParams,
  options?: Partial<UseQueryOptions<Pagination<ManualPaymentSlip>>>,
) {
  return useQuery({
    queryKey: [...MANUAL_PAYMENT_SLIPS_QUERY_KEY, params],
    queryFn: () => listManualPaymentSlips(params),
    enabled: Boolean(params.company_key),
    ...options,
  })
}
